import { combineReducers } from "redux";

import LoaderReducer from "./LoaderReducer";
import LoginReducer from "./LoginReducer";

const reducers = combineReducers({
   
    loader: LoaderReducer,
    auth:LoginReducer,
    
})

export default reducers;